<template>
  <v-container fluid fill-height class="pa-0">
    <v-toolbar color="#eee" app fixed class="elevation-0">
      <v-badge color="primary" overlap v-if="user">
        <v-icon
          slot="badge"
          dark
          small
        >menu</v-icon>
        <v-btn flat icon dark class="ma-0" @click.stop="menu = !menu">
          <v-avatar
            color="grey"
            size="30">
            <img v-if="user.image" :src="user.image" alt="trevor">
            <v-icon dark v-else>face</v-icon>
          </v-avatar>
        </v-btn>
      </v-badge>
      <v-spacer></v-spacer>
      <v-tooltip left v-if="frentistaSelecionado">
        <template v-slot:activator="{ on }">
          <v-chip
            v-if="frentista && posto"
            color="primary"
            dark
            v-on="on"
          >
            <v-avatar class="ma-0 pa-0">
              <img
                v-if="posto.url_logo"
                :src="posto.url_logo"
                alt="trevor"
              />
              <v-icon v-else>local_gas_station</v-icon>
            </v-avatar>
            {{ posto.nome_fantasia }}
          </v-chip>
          <v-chip
            v-else-if="frentista && empresa"
            color="primary"
            dark
            v-on="on"
          >
            <v-avatar class="ma-0 pa-0">
              <img
                v-if="empresa.url_logo"
                :src="empresa.url_logo"
                alt="trevor"
              />
              <v-icon v-else>mdi-domain</v-icon>
            </v-avatar>
            {{ empresa.nome_fantasia }}
          </v-chip>
        </template>
        <span>Empresa logada</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip left v-if="frentistaSelecionado && user">
        <template v-slot:activator="{ on }">
          <v-chip
            color="primary"
            dark
            class="ml-2"
            @click="dialogSelecionar = true"
            v-on="on"
          >
            <v-avatar class="ma-0 pa-0">
              <v-icon>face</v-icon>
            </v-avatar>
            {{ frentistaSelecionado.nome }} - {{ frentistaSelecionado.matricula }}
          </v-chip>
        </template>
        <span>Clique para mudar {{ posto ? 'frentista' : 'funcionário' }}</span>
      </v-tooltip>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-navigation-drawer
      v-if="dialogVouchers"
      v-model="dialogVouchers"
      fixed
      right
      temporary
      width="450"
    >
      <compras-em-dinheiro />
    </v-navigation-drawer>
    <v-navigation-drawer
      v-if="dialogRelatorioEmpresa"
      v-model="dialogRelatorioEmpresa"
      fixed
      right
      temporary
      width="450"
    >
      <relatorio-empresa />
    </v-navigation-drawer>
    <v-navigation-drawer
      v-if="dialogRelatorioPix"
      v-model="dialogRelatorioPix"
      fixed
      right
      temporary
      width="450"
    >
      <relatorio-pix />
    </v-navigation-drawer>
    <v-navigation-drawer v-model="history" fixed right temporary width="450">
      <historico-vouchers :history="history"/>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="menu"
      v-if="frentista && menu"
      fixed
      app
      left
      class="primary"
      dark
    >
      <v-layout column fill-height>
        <v-list two-line>
          <v-list-tile class="pt-5 pb-3" color="white">
          <v-layout column>
            <img
              :src="require('@/assets/logomarcadark.png')" style="width: 40px"
            />
            <span class="caption">{{user ? user.email : ''}}</span>
          </v-layout>
          <v-spacer/>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn flat icon @click="sair" v-on="on">
                <v-icon>exit_to_app</v-icon>
              </v-btn>
            </template>
            <span>Sair</span>
          </v-tooltip>
        </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <div class="scroll-y" style="max-height: calc(100% - 130px)">
            <v-list dense>
            <template v-for="(item, index) in items">
              <v-list-tile :key="index" ripple @click="item.funcao" class="pa-1">
                <v-list-tile-action>
                  <v-icon
                    size="32"
                  >
                    {{ item.icon }}
                  </v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title style="font-size: 1.2em; font-weight: 600;">
                    {{ item.text.toUpperCase() }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
          </div>
      </v-layout>
    </v-navigation-drawer>
    <v-content style="height: 100%">
      <v-toolbar absolute v-if="user && toolbar" color="primary">
          <v-spacer></v-spacer>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                @click="hide = !hide"
                class="mr-4"
                color="white"
                flat
                dark
                large
              >
                <v-icon size="35">local_gas_station</v-icon>
              </v-btn>
            </template>
            <span>{{ text }}</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                @click="dialogRelatorioEmpresa = true"
                class="mr-4"
                color="white"
                flat
                dark
                large
              >
                <v-icon size="35">mdi-domain</v-icon>
              </v-btn>
            </template>
            Vouchers Empresa
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                @click="dialogCashPosto = true"
                class="mr-4"
                color="white"
                flat
                dark
                large
              >
                <v-icon size="35">paid</v-icon>
              </v-btn>
            </template>
            Cash Posto retirado
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                @click="dialogAssinatura = true"
                class="mr-4"
                color="white"
                flat
                dark
                large
              >
                <v-icon size="35">edit</v-icon>
              </v-btn>
            </template>
            Assinatura do Usuário
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                @click="dialogRelatorioPix = true"
                class="mr-4"
                color="white"
                flat
                dark
                large
              >
                <v-icon size="35">receipt</v-icon>
              </v-btn>
            </template>
            <span>Pix Recebidos</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon @click="dialogPremios = true"
                class="mr-4"
                color="white"
                flat
                dark
                large
              >
                <v-icon size="35">card_giftcard</v-icon>
              </v-btn>
            </template>
            <span>Prêmios</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                @click="dialogVouchers = true"
                class="mr-4"
                color="white"
                flat
                dark
                large
              >
                <v-icon class="material-icons" size="35">local_atm</v-icon>
              </v-btn>
            </template>
            <span>Pagamento no posto</span>
          </v-tooltip>
          <v-tooltip v-if="frentista && !frentista.gerente" left>
            <v-btn
              slot="activator"
              icon
              @click="cadPin = true"
              class="mr-4"
              color="white"
              flat
              dark
              large
            >
              <v-icon size="35">fiber_pin</v-icon>
            </v-btn>
            <span>{{
              frentista.data_atualizacao_pin ? "Redefinir PIN" : "Cadastrar PIN"
            }}</span>
          </v-tooltip>
          <v-tooltip left v-if="frentista.gerente">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                @click="dialogFrentistas = true"
                class="mr-4"
                color="white"
                flat
                dark
                large
              >
                <v-icon size="35">people</v-icon>
              </v-btn>
            </template>
            <span>Frentistas</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="dialogCobranca = true" class="mr-4" color="white" flat dark large>
                <v-icon size="35">pix</v-icon>
              </v-btn>
            </template>
            <span>Faça uma cobrança pix</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="history = true" color="white" flat dark large>
                <v-icon size="35">history</v-icon>
              </v-btn>
            </template>
            <span>Histórico</span>
          </v-tooltip>
          <v-spacer></v-spacer>
      </v-toolbar>
      <v-alert
        v-if="updateVersion || hasNewVersion"
        :value="true"
        type="error"
        class="pa-1"
        icon="update"
      >
        <v-layout>
          <div class="mt-2">Uma nova atualização está disponível</div>
          <v-spacer></v-spacer>
          <v-btn small @click="atualizar">Atualizar</v-btn>
        </v-layout>
      </v-alert>
      <router-view></router-view>
      <v-layout justify-center>
        <v-flex xs8>
          <precos-list v-if="frentista && !hide"></precos-list>
        </v-flex>
      </v-layout>
    </v-content>
    <v-dialog lazy width="800" v-model="dialogFrentistas" persistent>
      <frentistas-posto
        :visible="dialogFrentistas"
        v-if="dialogFrentistas"
        @close="dialogFrentistas = false"
      ></frentistas-posto>
    </v-dialog>
    <v-dialog v-if="cadPin" v-model="cadPin" persistent max-width="360">
      <cad-pin @fechar="cadPin = false" :frentistaSelecionado="frentista" />
    </v-dialog>
    <v-dialog
      v-if="dialogSelecionar"
      v-model="dialogSelecionar"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <selecionar-frentista
        @fechar="dialogSelecionar = false"
        :frentista="frentista"
      />
    </v-dialog>
    <v-dialog v-if="dialogCobranca" v-model="dialogCobranca" persistent width="450">
      <dialog-cobranca
        @fechar="dialogCobranca = false"
        :frentistaSelecionado="frentista"
      />
    </v-dialog>
    <v-dialog v-model="dialogPremios" v-if="dialogPremios" width="50em">
      <voucher-premio
        @fechar="dialogPremios=false"
      />
    </v-dialog>
    <v-dialog v-model="dialogCashPosto" v-if="dialogCashPosto" width="50em">
      <cash-posto
        @fechar="dialogCashPosto=false"
      />
    </v-dialog>
    <v-dialog v-model="dialogAssinatura" v-if="dialogAssinatura" width="50em">
      <assinatura
        @fechar="dialogAssinatura=false"
      />
    </v-dialog>
  </v-container>
</template>
<script>

import CadPin from '@/components/dialogs/CadPin'
import FrentistasPosto from '@/components/dialogs/FrentistasPosto'
import ComprasEmDinheiro from '@/components/dialogs/ComprasEmDinheiro'
import RelatorioEmpresa from '@/components/dialogs/RelatorioEmpresa'
import RelatorioPix from '@/components/dialogs/RelatorioPixRecebido'
import SelecionarFrentista from '@/components/dialogs/DialogSelecionarFrentista'
import DialogCobranca from '@/components/dialogs/DialogCobranca'
import PrecosList from '@/components/PrecosList'
import VoucherPremio from '@/components/dialogs/VoucherPremio'
import HistoricoVouchers from '@/components/dialogs/HistoricoVouchers'
import CashPosto from '@/components/dialogs/CashPosto'
import Assinatura from '@/components/dialogs/Assinatura'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { version, name } from '../../../package.json'

export default {
  components: {
    HistoricoVouchers,
    FrentistasPosto,
    ComprasEmDinheiro,
    PrecosList,
    CadPin,
    RelatorioEmpresa,
    RelatorioPix,
    SelecionarFrentista,
    DialogCobranca,
    VoucherPremio,
    CashPosto,
    Assinatura
  },
  data () {
    return {
      hide: true,
      text: 'Esconder combustíveis',
      history: false,
      dialogFrentistas: false,
      dialogSelecionar: false,
      voucher: null,
      dialogVouchers: false,
      dialogPremios: false,
      dialogRelatorioEmpresa: false,
      dialogRelatorioPix: false,
      dialogCashPosto: false,
      dialogAssinatura: false,
      database: null,
      listener: null,
      cadPin: false,
      dialogUpdate: false,
      dialogCobranca: false,
      menu: false,
      toolbar: false,
      largura_tela: 0,
      items: [
        {
          icon: 'history',
          text: 'Histórico',
          funcao: () => { this.history = true },
          color: 'gray'
        },
        {
          icon: 'local_atm',
          text: 'Compras no Posto',
          funcao: () => { this.dialogVouchers = true },
          color: 'success'
        },
        {
          icon: 'mdi-domain',
          text: 'Voucher da Empresa',
          funcao: () => { this.dialogRelatorioEmpresa = true },
          color: 'secondary'
        },
        {
          icon: 'pix',
          text: 'PIX',
          funcao: () => { this.dialogCobranca = true },
          color: 'teal'
        },
        {
          icon: 'receipt',
          text: 'PIX recebidos',
          funcao: () => { this.dialogRelatorioPix = true },
          color: 'yellow lighten-3'
        },
        {
          icon: 'card_giftcard',
          text: 'Prêmios',
          funcao: () => { this.dialogPremios = true },
          color: 'error'
        },
        {
          icon: 'paid',
          text: 'Cash Posto',
          funcao: () => { this.dialogCashPosto = true },
          color: 'success'
        },
        {
          icon: 'edit',
          text: 'Assinatura do Usuário',
          funcao: () => { this.dialogAssinatura = true },
          color: 'success'
        },
        {
          icon: 'people',
          text: 'Frentista do Posto',
          funcao: () => { this.dialogFrentistas = true },
          color: 'blue-grey darken-1'
        },
        {
          icon: 'local_gas_station',
          text: 'Mostrar combustíveis',
          funcao: () => { this.hide = !this.hide },
          color: 'primary'
        }
      ]
    }
  },
  mounted () {
    this.database = firebase.firestore()
    if (this.user) {
      this.$store.dispatch('loadCombustiveis').then(() => {
        if (this.posto) this.$store.dispatch('carregarItens')
      })
    }
  },
  watch: {
    versao (val) {
      this.$store.dispatch('verificarAtualizacao', {
        name: name,
        version: val
      })
    },
    user (val) {
      if (val) {
        this.$store.dispatch('loadCombustiveis').then(() => {
          if (this.posto) this.$store.dispatch('carregarItens')
        })
        let document = this.database
          .collection(val.frentista.posto ? `postos` : 'empresas')
          .doc(val.frentista.posto ? `${val.frentista.posto.cnpj}` : `${val.frentista.empresa.cnpj}`)
          .collection('vouchers-lidos')
          .orderBy('timestamp', 'desc')
          .limit(1)
        this.listener = document.onSnapshot(this.showSnapshot, err => {
          console.log(err)
        })
      } else if (this.listener) {
        this.listener()
      }
    },
    hide (val) {
      this.items[this.items.length - 1].text = !val ? 'Esconder combustíveis' : 'Mostrar combustíveis'
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    historyVouchers () {
      return this.$store.getters.historyVouchers
    },
    frentista () {
      return this.$store.getters.frentista
    },
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    hasNewVersion () {
      return this.$store.getters.hasNewVersion
    },
    versao () {
      return this.$store.getters.versao
    },
    updateVersion () {
      return this.$store.getters.versao !== version
    },
    posto () {
      return this.$store.getters.posto
    },
    empresa () {
      return this.$store.getters.empresa
    },
    tela () {
      return Number(window.innerWidth)
    }
  },
  created () {
    this.$store.dispatch('verificarAtualizacao', {
      name: name,
      version: version
    })
    this.lagura_tela = this.tela
    if (this.lagura_tela >= 1264) {
      this.menu = true
    } else {
      this.toolbar = true
    }
  },
  methods: {
    atualizar () {
      this.$store.dispatch('atualizarVersao', {
        name: name,
        version: version
      })
      window.location.reload(true)
    },
    sair () {
      this.$store.dispatch('signUserOut')
    },
    showSnapshot (snapshot) {
      snapshot.docChanges().forEach(change => {
        if (change.type === 'added') {
          this.$store.dispatch('addVoucherHistory', change.doc.data())
        }
      })
    }
  }
}
</script>
